import { useTheme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import Button from '@mui/material/Button';
import { IconCloud } from '@experimental-components/IconsComponents/Cloud';

const ButtonCloudBase = withStyles((theme) => ({
  root: {
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: theme.typography.pxToRem(16),
    padding: theme.typography.pxToRem(12),
    border: 'none',
    lineHeight: theme.typography.pxToRem(18),
    height: theme.typography.pxToRem(42),
    minWidth: 'min-content',
    backgroundColor: (props) => (props.variant === 'black' ? theme.palette.common.black : theme.palette.darkGrey[2]),
    color: (props) => (props.variant === 'black' ? theme.palette.common.white : theme.palette.common.black),

    '&:hover': {
      backgroundColor: (props) => (props.variant === 'black' ? theme.palette.common.black : theme.palette.darkGrey[5]),
      boxShadow: 'none',
    },

    '&:active': {
      boxShadow: 'none',
      backgroundColor: (props) => (props.variant === 'black' ? theme.palette.common.black : theme.palette.darkGrey[2]),
    },

    '&:focus': {
      border: 'none',
    },

    '&$disabled': {
      color: (props) => (props.variant === 'black' ? theme.palette.darkGrey[50] : theme.palette.darkGrey[50]),
    },
  },

  disabled: {
    backgroundColor: (props) =>
      props.variant === 'black' ? theme.palette.common.black : theme.palette.action.disabledBackground,
    color: (props) => (props.variant === 'black' ? theme.palette.common.white : theme.palette.darkGrey[50]),
  },

  sizeSmall: {
    padding: 16,
  },
  startIcon: {
    margin: 0,
    paddingRight: (props) => (props.children ? 8 : 0),
  },
}))(Button);

export const ButtonCloud = ({ disabled = false, isDisabled = false, variant = 'default', ...others }) => {
  const theme = useTheme();
  const color = variant === 'black' ? 'white' : 'black';
  return (
    <ButtonCloudBase
      disableElevation
      disableRipple
      disabled={disabled || isDisabled}
      startIcon={<IconCloud color={disabled || isDisabled ? theme.palette.darkGrey[50] : color} size={16} />}
      variant={variant}
      {...others}
    />
  );
};
